import React, { FunctionComponent } from "react";
import { BeigeContainer } from "./styles";
import { IProps } from "./types";

const BottomContainer: FunctionComponent<IProps> = (props: IProps) => {
  return <BeigeContainer>{props.children}</BeigeContainer>;
};

export default BottomContainer;
